export default {
  ALLOW_FULLSCREEN: 'allowfullscreen',
};
